import React from 'react';

function SideDrawerBackIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M9.78341 13.1674L4.7998 8.1838L9.78341 3.2002" stroke="#08081B" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>  );
}

export default SideDrawerBackIcon;